import {
    Card,
    CardContent,
    Grid,
    Stack,
    Tooltip,
    Typography,
} from "@mui/material";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { totalPrice } from "../purchase/purFunction";
export default function PurchaseItemsCards({
    index,
    item,
    arr,
    setFormData,
}) {
    console.log("item ", item);
    return (
        <Card
            sx={{
                width: "100%",
                m: "0px",
                mt: "10px",
                p: "0px",

                cursor: "pointer",
                ":hover": {
                    bgcolor: "#2892ba17",
                },
            }}
        //   onClick={callBack}
        //   onClick={setEditedItem}
        >
            <CardContent sx={{ p: "0px !important", display: "flex", justifyContent: "space-between" }}>
                <Grid container xs={12}>
                    <Grid item xs={12} sx={{ display: "flex", justifyContent: "space-between", p: "8px" }}>
                        <Typography
                            color="primary"
                            sx={{
                                fontSize: "15px",
                                // overflow: "Hidden",
                                // textOverflow: "ellipsis",
                                display: "-webkit-box",
                                "-webkit-line-clamp": "1",
                                "-webkit-box-orient": "vertical",
                            }}
                        >
                            {item?.itemDescription}
                        </Typography>
                        <DeleteIcon
                            onClick={() => {
                                let arr1 = [...arr.purchaseItems];
                                arr1.splice(index, 1);
                                
                                setFormData({ ...arr, purchaseItems: arr1 ,
                                                    totalAmount:parseFloat( totalPrice(arr1)),
                                    
                                });
                            }}
                        />
                    </Grid>
                    <Grid container item xs={12} sx={{ display: "flex", paddingX: "8px" }}>
                        <Grid item xs={4}>
                            <Typography
                                color="secondary"
                                sx={{
                                    fontSize: "15px",
                                    overflow: "Hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    "-webkit-line-clamp": "1",
                                    "-webkit-box-orient": "vertical",
                                }}
                            >
                                Qty : {item?.quantity}
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography
                                color="secondary"
                                sx={{
                                    fontSize: "15px",
                                    overflow: "Hidden",
                                    textOverflow: "ellipsis",
                                    // textAlign: "center",
                                    display: "-webkit-box",
                                    "-webkit-line-clamp": "1",
                                    "-webkit-box-orient": "vertical",
                                }}
                            > Unit Price :
                                <CurrencyRupeeIcon color="black" sx={{
                                    fontSize: "15px",
                                }} />{item?.unitPrice}
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography
                                color="primary"
                                sx={{
                                    fontSize: "15px",
                                    overflow: "Hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    "-webkit-line-clamp": "1",
                                    "-webkit-box-orient": "vertical",
                                }}
                            >
                                Total :
                                <CurrencyRupeeIcon color="black" sx={{
                                    fontSize: "15px"
                                }} /> {item?.subTotal}
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container item xs={12} sx={{ display: "flex", paddingX: "8px" }}>
                        <Grid item xs={4}>
                            <Typography
                                color="secondary"
                                sx={{
                                    fontSize: "15px",
                                    overflow: "Hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    "-webkit-line-clamp": "1",
                                    "-webkit-box-orient": "vertical",
                                }}
                            >
                                CGST :
                                <CurrencyRupeeIcon color="black" sx={{
                                    fontSize: "15px",
                                }} />{item?.cgst}
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography
                                color="secondary"
                                sx={{
                                    fontSize: "15px",
                                    overflow: "Hidden",
                                    textOverflow: "ellipsis",
                                    // textAlign: "center",
                                    display: "-webkit-box",
                                    "-webkit-line-clamp": "1",
                                    "-webkit-box-orient": "vertical",
                                }}
                            >
                                SGST :
                                <CurrencyRupeeIcon color="black" sx={{
                                    fontSize: "15px",
                                }} />{item?.sgst}
                            </Typography>
                        </Grid>

                        <Grid item xs={4}>
                            <Typography
                                color="secondary"
                                sx={{
                                    fontSize: "15px",
                                    overflow: "Hidden",
                                    textOverflow: "ellipsis",
                                    display: "-webkit-box",
                                    "-webkit-line-clamp": "1",
                                    "-webkit-box-orient": "vertical",
                                }}
                            >
                                IGST :
                                <CurrencyRupeeIcon color="black" sx={{
                                    fontSize: "15px"
                                }} /> {item?.igst}
                            </Typography>
                        </Grid>
                    </Grid>

                </Grid>
            </CardContent>
        </Card>
    );
}
